/**
 * Couche API — point central de configuration.
 *
 * Les modules branchés (connexion, référentiel, élèves & inscriptions, RH) appellent le backend
 * via `http.ts`. Les modules pas encore branchés (finances, paiements, fiche, plateforme…)
 * utilisent encore des données de démonstration, signalées à l'écran par un bandeau.
 */

/**
 * URL de l’API. En production, chemin relatif (« /api/v1 ») : Nginx sert le site et l’API sur le même domaine.
 * En développement, le backend tourne à part sur le port 3000.
 */
export const API_BASE_URL =
  (import.meta.env.VITE_PUBLIC_API_BASE_URL as string | undefined) ??
  (import.meta.env.DEV ? "http://localhost:3000/api/v1" : "/api/v1");

/** Modules en démonstration : simule une latence réseau afin que l'UI soit déjà asynchrone. */
export function delay<T>(data: T, ms = 220): Promise<T> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(data), ms);
  });
}

/** Modules en démonstration : identifiant unique simple pour les créations. */
export function uid(prefix: string): string {
  return `${prefix}-${Math.random().toString(36).slice(2, 8)}${Date.now()
    .toString(36)
    .slice(-4)}`;
}
